import React, { useEffect, useRef, useState } from "react";
import bell_icon from "../assests/bell_icon.svg";
import { getNotifications, updateNotification } from "../services/ApiService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { convertDate } from "../utils/date_format";
import {getIconSrc, getPlatformImg} from "../helpers/getImgSrc"
import { UPDATE_FILTER_DATA } from "../redux/features/user/filterSlice";
import { useDispatch } from "react-redux";
import { getPlatformName } from "../helpers/getPlatformName";

export const Notifications = () => {
  const user = useSelector((state) => state?.user);
  const navigate = useNavigate();
  const panelRef = useRef();
  const dispatch=useDispatch()

  const [showPanel, setShowPanel] = useState(false);
  const [activeTab, setActiveTab] = useState("View All");
  const [notifications, setNotifications] = useState([]);

  // Fetch notifications from the API
  const fetchNotifications = async () => {
    try {
      const result = await getNotifications(user?.client_id);
      if (result) {
        setNotifications(result?.notifications || []);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    // Fetch notifications immediately on mount
    fetchNotifications();

    // Set interval to fetch notifications every 1 minute (60000 ms)
    const intervalId = setInterval(fetchNotifications, 600000);

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);


  // Click outside to close the notification panel
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close panel if the click is outside the panel and the bell icon
      if (
        showPanel &&
        panelRef.current &&
        !panelRef.current.contains(event.target) &&
        !event.target.closest(".bell-icon") // Ignore clicks on the bell icon
      ) {
        setShowPanel(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showPanel]);

  // Mark a notification as read
  const markAsRead = async (notification_id) => {
    try {
      const result = await updateNotification(notification_id);
      if (result?.success) {
        fetchNotifications();
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  // Mark all notifications as read
  const markAllAsRead = () => {
   
  };

  // Filter notifications based on active tab
  const getFilteredNotifications = () => {
    switch (activeTab) {
      case "Campaign Activation":
        return notifications.filter((notification) =>
          notification.title.includes("Campaign Found")
        );
      case "Insights":
        return notifications.filter((notification) =>
          notification.title.includes("Opportunity Identified")
        );
      case "View All":
        return notifications;
      default:
        return notifications;
    }
  };

  // Render individual notifications
  const renderNotifications = (notificationsToRender) => {
    if (notificationsToRender.length === 0) {
      return <div className="text-center">No notifications available.</div>;
    }
    return notificationsToRender.map((notification) => (
      <div
        key={notification.notification_id}
        className={`d-flex align-items-start mb-3 position-relative p-2  `}
        style={{
          cursor: "pointer",
          backgroundColor: !notification.is_read ? "#F8F6FD" : "transparent", // Light background for unread
          borderRadius: !notification.is_read ? "4px" : "0", // Rounded corners for unread
        }}

      >
        <img
          src={getPlatformImg(notification?.platform_id)}
          alt={notification.title}
          className="rounded rounded-5 me-3"
          style={{ width: "40px", height: "40px" }}
        />
        <div className="d-flex flex-column gap-3">
          <span
            className={`fw-bold fs-6 ${notification.is_read ? "text-muted" : ""}`}
          >
            {notification.title}
          </span>
          <span className={`small ${notification.is_read ? "text-muted" : ""}`}>
            {notification.description}
          </span>
          <span>
            <button
              className="btn btn-sm rounded-pill btn-primary rounded-fill px-4"
              onClick={() => {
                markAsRead(notification.notification_id);
                //choose a platform
                if(notification?.target_component==="/settings/link-ads")
                {
                        dispatch(UPDATE_FILTER_DATA({filter_ads_selected_platform:
                  {platform_id:notification?.platform_id,
                    social_media_type:notification?.account_details?.media_type,
                    accountDetails:notification?.account_details
                  }}))

                }else{
                         dispatch(UPDATE_FILTER_DATA({select_organic_social_platform:{
                          platform_id:notification?.platform_id,
                          platform_name:getPlatformName(notification?.platform_id)
                         }}))

                }
          
               
                navigate(`/client${notification?.target_component || ""}`, { state: { platform_id: notification?.platform_id } });
                setShowPanel(false);
              }}
            > 
              {notification.action_btn_title}
            </button>
          </span>
          <div className="text-muted small">{convertDate(notification.created_at)}</div>
        </div>

        {/* Red dot for unread notifications */}
        {!notification.is_read && (
          <span className="position-absolute top-1 end-0 translate-middle p-1 bg-warning rounded-circle " />
        )}
      </div>
    ));
  };

  return (
    <div>
      {/* Bell Icon */}
      <div
        className={`bell-icon p-2 notification ${
          showPanel && "bg-white  border_radius_sm custom_border "
        }`} // Add class for the bell icon to prevent closing the panel on click
        onClick={() => {
          setShowPanel((prev) => !prev);
          fetchNotifications();
        }}
        style={{ position: "relative", cursor: "pointer" }}
         data-bs-toggle="tooltip" data-bs-placement="top" title="Get alerts for new ads and posts."
      >
        <img src={bell_icon} alt="Notifications" />
        {notifications.filter((notification) => !notification.is_read).length >
          0 && (
          <span className="position-absolute top-1 end-0 translate-middle p-1 bg-warning rounded-circle " />
        )}
      </div>

      {/* Notification Panel */}
      {showPanel && (
        <div
          ref={panelRef} // Attach panelRef here
          className="position-fixed bg-white rounded rounded-4"
          style={{
            top: "80px",
            right: "20px",
            width: "450px",
            height: "auto",
            zIndex: 1050,
            maxWidth: "90vw",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)", // Apply shadow for the notification panel
            transition: "all 0.3s ease-in-out", // Smooth transition for opening/closing
          }}
        >
          {/* Header */}
          <div className="p-3 border_bottom d-flex justify-content-between">
            <div className="d-flex gap-2 align-items-center">
              <div>
                <span className="fw-bold">Notifications</span>
              </div>
              <div className="notification_badge">
                <span>
                  {
                    notifications.filter(
                      (notification) => !notification.is_read
                    ).length
                  }
                </span>
              </div>
            </div>
            <div className="close-button" onClick={() => setShowPanel(false)}>
              <img src={getIconSrc("cross", "svg")} alt="" />
            </div>
          </div>

          {/* Body */}
          <div className="overflow-auto" style={{ height: "70vh" }}>
            <div className=" p-3 ">
              <div className="d-flex gap-4 mb-3" style={{ cursor: "pointer" }}>
                <div
                  className={`${
                    activeTab === "View All" ? "active" : "text-muted"
                  }`}
                  onClick={() => setActiveTab("View All")}
                  style={{
                    borderBottom:
                      activeTab === "View All" ? "2px solid #7f56d9" : "none",
                    fontWeight: activeTab === "View All" ? "bold" : "normal",
                  }}
                >
                  View All
                </div>

                <div
                  className={`${
                    activeTab === "Campaign Activation"
                      ? "active"
                      : "text-muted"
                  }`}
                  onClick={() => setActiveTab("Campaign Activation")}
                  style={{
                    borderBottom:
                      activeTab === "Campaign Activation"
                        ? "2px solid #7f56d9"
                        : "none",
                    fontWeight:
                      activeTab === "Campaign Activation" ? "bold" : "normal",
                  }}
                >
                  Campaign Activation
                </div>

                <div
                  className={`${
                    activeTab === "Insights" ? "active" : "text-muted"
                  }`}
                  onClick={() => setActiveTab("Insights")}
                  style={{
                    borderBottom:
                      activeTab === "Insights" ? "2px solid #7f56d9" : "none",
                    fontWeight: activeTab === "Insights" ? "bold" : "normal",
                  }}
                >
                  Insights
                </div>
              </div>
              {renderNotifications(getFilteredNotifications())}
            </div>
          </div>

          {/* Footer */}
          <div className="d-flex justify-content-between align-items-center border_top p-3">
            {/* <small
              className="text_primary"
              style={{ cursor: "pointer" }}
              onClick={markAllAsRead}
            >
              Mark All as Read
            </small>
            <button className="btn btn-sm rounded-pill btn-primary rounded-fill px-4">
              View All Notifications
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
};
